import { APIRoute } from '@/modules/utils'
import { Petsitter } from '@/dataV3/PetSitter/Petsitter'

export const Route: APIRoute = {
  method: 'GET',
  path: '/v2/petsitting/account',
}

export type Response = Petsitter
